const headers = {
  name: "Sales Invoices",
  components: [
    {
      type: "search",
      name: "search",
      placeholder: "Search",
      value: "",
    },
    {
      type: "select",
      name: "sort",
      placeholder: "Sort",
      allowClear: true,
      showSearch: false,
      filterOption: true,
      value: null,
      options: [
        { value: 0, label: "Price (Low-High)" },
        { value: 1, label: "Price (High-Low)" },
      ],
    },
    {
      type: "filter",
      name: "customer",
      allowClear: true,
      showSearch: true,
      filterOption: false,
      placeholder: "Customer",
      api: "get-all-customers",
      value: null,
      options: null,
    },
    {
      type: "filter",
      name: "payment",
      placeholder: "Payments",
      value: null,
      allowClear: true,
      showSearch: false,
      filterOption: true,
      options: [
        {
          value: "Cash",
          label: "Cash",
        },
        {
          value: "Debit card",
          label: "Debit card",
        },
        {
          value: "Bank transfer",
          label: "Bank transfer",
        },
        {
          value: "Credit card",
          label: "Credit card",
        },
        {
          value: "Cheque",
          label: "Cheque",
        },
        {
          value: "Online payment",
          label: "Online payment",
        },
      ],
    },
    {
      type: "range",
      name: "date",
      value: {
        start: "",
        end: "",
      },
    },
    {
      type: "range",
      name: "due_date",
      placeholder: ["Due Start Date", "Due End Date"],
      value: {
        start: "",
        end: "",
      },
    },
    {
      type: "add",
      path: "/app/sales/invoices/add",
    },
  ],
  navigate: {
    tabs: [
      {
        name: "SO",
        path: "/app/sales/sales-order",
      },
      {
        name: "DO",
        path: "/app/sales/delivery-note",
      },
      {
        name: "Invoices",
        path: "",
      },
      {
        name: "Returns",
        path: "/app/sales/returns",
      },
      {
        name: "Quotes",
        path: "/app/sales/quotes",
      },
      {
        name: "Bookings",
        path: "/app/sales/bookings",
      },
      {
        name: "Credit Notes",
        path: "/app/sales/credit-notes",
      },
    ],
    total: [
      { value: 0, label: "Total" },
      { value: 0, label: "Active" },
      { value: 0, label: "Inactive" },
    ],
  },
};

export default headers;
